import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as PropTypes from 'prop-types';
import {
  Layout, Row, Typography,
} from 'antd';
import './Section.css';

const { Text } = Typography;

/**
 * Bynx Header - Section
 * @param title heading text
 */
function SectionHeader({ titleId }) {
  return (
    <Layout className="via-header-section">
      <Row className="via-header-view" align="middle" justify="start" type="flex">
        <Text className="via-header-section-title"><FormattedMessage id={titleId} /></Text>
      </Row>
    </Layout>
  );
}

// Validate the prop type parameters.
SectionHeader.propTypes = {
  titleId: PropTypes.string.isRequired,
};

export default SectionHeader;
